"use strict";

exports.__esModule = true;
var _Screen = require("./Screen");
Object.keys(_Screen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Screen[key]) return;
  exports[key] = _Screen[key];
});